export default __webpack_public_path__ + "static/media/edit_news_announcement.8ac79fe6.svg";